import {
	SET_PURCHASE_LOADING,
	SET_PURCHASE_SUCCESS,
	SET_PURCHASE_FAIL,
	CLEAR_PURCHASES,
} from '../constants';

const initialState = {};

const purchases = (state = initialState, action) => {
	switch (action.type) {
		case SET_PURCHASE_LOADING:
			return {
				...state,
				[action.payload.sku]: {
					isLoading: action.payload.isLoading,
				},
			};
		case SET_PURCHASE_SUCCESS:
			return {
				...state,
				[action.payload.sku]: {
					success: true,
				},
			};
		case SET_PURCHASE_FAIL:
			return {
				...state,
				[action.payload.sku]: {},
			};
		case CLEAR_PURCHASES:
			return initialState;
		default:
			return state;
	}
};

export default purchases;



// WEBPACK FOOTER //
// ./src/reducers/purchases.js